/**
 *
 */
import WithAndWithoutItem from "./withAndWithoutItem";

type Compare = {
    id : string
    url : string
    name : string
    score : number
    ratio : number
    count : number
};

/**
 *
 */
type Data = {
    compareWith : Compare
    compareWithout : Compare
};

/**
 *
 * @param without
 * @constructor
 */
export default function WithAndWithout ({ compareWith, compareWithout  } : Data) {
    // render
    return (
        <>
            <div className={'d-md-flex align-items-md-center'}>
                <WithAndWithoutItem
                    compare={
                        {
                            id: compareWith.id,
                            title: compareWith.name,
                            link: compareWith.url,
                            score: compareWith.score,
                            ratio: compareWith.ratio,
                            count: compareWith.count
                        }
                    }
                />
                <p className={'col-12 col-md-2 mb-3 text-center h1 fw-bold'}>VS</p>
                <WithAndWithoutItem
                    compare={
                        {
                            id: compareWithout.id,
                            title: compareWithout.name,
                            link: compareWithout.url,
                            score: compareWithout.score,
                            ratio: compareWithout.ratio,
                            count: compareWithout.count
                        }
                    }
                />
            </div>
        </>
    );
}